<!--
  - Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->
<script>
export default {
  name: "StringHelpersMixin",

  methods: {
    truncate(s, n, useWordBoundary) {
      if (!s) {
        return s
      }
      if (s.length <= n) {
        return s
      }
      let subString = s.substr(0, n - 1)
      return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString) + "&hellip;"
    },

    encode(value, style) {
      if (value) {
        // Allow styling to be specified dynamically
        return "<p" + (style ? ' style="' + style + '"' : "") + ">" + this.$he.encode(value) + "</p>"
      }

      // maybe return <p></p> here?
      return value
    },

    decode(value) {
      if (value) {
        let val = this.removePTags(value)

        // Decode HTML entities
        val = this.$he.decode(val)

        // Remove any other HTML markup
        val = val.replace(/(<([^>]+)>)/gi, "")
        // Remove any whitespaces that may have been introduced by replacing </p> above
        return val
      }

      // maybe return <p></p> here?
      return value
    },

    // Remove <p> tags, replace </p> tags with blank
    removePTags(value) {
      if (value) {
        let val = value.replace(/<p[^>]*>/g, "")
        return val.replace(/<\/p>/g, "")
      } else {
        return value
      }
    },

    // Removes tags which may be inline with other replace
    removeNonBreakingTags(value) {
      if (value) {
        // Only em, strong, u, span with font-size and s are non-breaking for now
        value = value.replace(/<(\/)*(em|strong|u|span[^>]font-size|s[^pan])[^>]*>/gi, "")
        return value.replace(/<(\/span)[^>]*>/gi, "")
      } else {
        return value
      }
    },

    // Replaces all tags for a white space, for RichTextEditor
    replaceAllTags(value) {
      if (value) {
        return value.replace(/(<([^>]+)>)/gi, "")
      } else {
        return value
      }
    },

    // Remove all tags if type equals messagericheditor
    formatMessageInteraction(value) {
      let val
      val = this.removeNonBreakingTags(value)
      val = this.replaceAllTags(val)
      val = val.replace(/\s{2,}/g, " ")
      if (val === "" && value.indexOf("<img") != -1) {
        val = "IMG"
      } else if (val.length > 300) {
        val = val.substring(0, 300) + "..."
      }
      return val
    },
  },
}
</script>

<style scoped></style>
